import $http from './http';
// 考察列表
export function offList(data) {
    return $http({
        url: `/xmt/offlineInspection/offList`,
        data: data
    });
}
// 考察详情
export function selectDetal(data) {
    return $http({
        url: `/xmt/offlineInspection/selectDetal`,
        data: data
    });
}
// 人才结果公示详情页
export function getResultDetail(data) {
    return $http({
        url: `/xmt/publicity/getOnepublicity`,
        data: data
    });
}
// 批量面试
export function batchInterview(data) {
    return $http({
        url: `/xmt/offlineInspection/batchInterview`,
        method: 'post',
        data: data
    });
}
// 批量二面面试
export function batchInterviewRetest(data) {
    return $http({
        url: `/xmt/offlineInspection/batchInterviewRetest`,
        method: 'post',
        data: data
    });
}
// 批量考察
export function batchInspection(data) {
    return $http({
        url: `/xmt/offlineInspection/batchInspection`,
        method: 'post',
        data: data
    });
}
// 批量体检
export function batchCheckup(data) {
    return $http({
        url: `/xmt/offlineInspection/batchCheckup`,
        method: 'post',
        data: data
    });
}
